import styled from 'styled-components';
import { Heading, spaceMixin, StyledButton } from '@zillow/constellation';
import {
    ButtonGroup,
} from '@zillow/zrs-comet';

export const CenteredButtonGroup = styled(ButtonGroup)`
    margin: auto auto ${spaceMixin('xl')} auto;

    ${StyledButton} {
        height: auto;
    }
`;

export const StyledHeading = styled(Heading)`
    font-size: 20px;
`;
